import { trpc } from "../trpc";

export function useAppConnectionSharingConfig(): {
  shareWithEveryoneEnabled: boolean;
  isLoading: boolean;
  error: unknown;
} {
  const { data, isLoading, error } =
    trpc.account.appConnectionSharingConfig.useQuery();

  return {
    shareWithEveryoneEnabled: data?.shareWithEveryoneEnabled ?? true,
    isLoading,
    error,
  };
}
